module.exports = __webpack_public_path__ + "images/evening-b8cc27c135e99f43034a8344919ac7c8.jpg";